<template>
    <div>
        <v-card class="pa-5" elevation="0">
            <h2>{{ $store.getters.t('트래픽 (Traffic)') }}</h2>
            <div ref="vodFluxChart" style="width: 100%; height: 400px;"></div>
        </v-card>
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'VodFlux',
    data() {
        return {
            chartInstance: null,
            trafficUnit: 'G'
        };
    },
    props: ['trafficData'],
    methods: {
        initChart() {
            const chartDom = this.$refs.vodFluxChart;
            if (chartDom) {
                if (this.chartInstance) {
                    this.chartInstance.dispose();
                }
                this.chartInstance = echarts.init(chartDom);
                this.updateChart();
            } else {
                console.error('Chart DOM not found');
            }
        },
        updateChart() {
            if (this.chartInstance && this.trafficData) {
                const data = this.trafficData.map(item => {
                    let value = item.Value;
                    switch (this.trafficUnit) {
                        case 'M':
                            value *= 1024;
                            break;
                        case 'G':
                            value;
                            break;
                        case 'T':
                            value /= 1024;
                            break;
                        default:
                            break;
                    }
                    return [item.Timestamp, value.toFixed(2)];
                });
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'cross' }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'time',
                        splitLine: { show: false }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: { formatter: `{value} GB` }
                    },
                    series: [{
                        name: 'Traffic',
                        type: 'line',
                        data: data,
                        smooth: true,
                        label: { show: false, position: 'top', fontSize: 10 }
                    }]
                };
                this.chartInstance.setOption(option, true);
            } else {
                console.error('traffic instance error');
            }
        },
    },
    watch: {
        trafficData(newData) {
            if (newData && newData.length > 0) {
                this.initChart();
            }
        },
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
        }
    }
};
</script>

<style scoped>
.primary {
    color: #006cea;
}
</style>